import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { createNotification } from '@/app/module/notifications/store/actions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import download from '@/app/service/util/download'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useDownloadCallRecording = () => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)

  const triggerDownload = useCallback(
    async (recordingId: number) => {
      if (!orgId) return false
      try {
        await download.recordings(orgId, recordingId)
        return true
      } catch {
        dispatch(
          createNotification({
            'accept-invitation-signup-error': {
              type: 'error',
              message: 'Cannot download recording, please try again later',
            },
          }),
        )
        return false
      }
    },
    [orgId, dispatch],
  )

  return [triggerDownload] as const
}
